module.exports = __webpack_public_path__ + "static/media/ic-faq.f3c486e8.svg";